import { css } from '@emotion/react';
import { standardSpacing } from 'styles/global_defaults/scaffolding';
import { info } from 'styles/global_defaults/colors';

import AvailabilityCalendarPeriod from './availability-calendar-period';
import AvailabilityCalendarButtons from './availability-calendar-buttons';

const styles = css`
  background-color: ${info};
  padding: ${standardSpacing}px;
`;

const AvailabilityCalendarHeader = () => (
  <div
    css={styles}
    className='d-flex justify-content-between align-items-center pb-1 pt-2'
  >
    <AvailabilityCalendarPeriod />
    <AvailabilityCalendarButtons />
  </div>
);

export default AvailabilityCalendarHeader;
